import axios from 'axios'
import axiosRetry from 'axios-retry'
import { withInterceptors, withProfileSearchRouting } from '@/rest/interceptors'

export const axiosInstance = withProfileSearchRouting(
  withInterceptors(
    axios.create({
      baseURL: process.env.VUE_APP_REST_API_BASE_URL,
    })
  )
)

/**
 * Retry on network errors or 5xx server errors.
 */
export const defaultRetryCondition = (error) =>
  axiosRetry.isNetworkOrIdempotentRequestError(error) ||
  (error.response?.status >= 500 && error.response?.status < 600)

axiosRetry(axiosInstance, {
  retries: 3,
  retryDelay: axiosRetry.exponentialDelay,
  retryCondition: defaultRetryCondition,
})
